import {randomKey} from '../commonUtils';
import {Keyed} from './arrayUtils.types';

function addRandomKeyToObjectArray<T>(array: Array<T>): Keyed<T>[] {
  return array.map((obj) => {
    return {...obj, key: randomKey()};
  });
}

export default addRandomKeyToObjectArray;
